export var MaritalStatus;
(function (MaritalStatus) {
    MaritalStatus["Married"] = "married";
    MaritalStatus["Single"] = "single";
    MaritalStatus["CommonLaw"] = "commonLaw";
})(MaritalStatus || (MaritalStatus = {}));
export var Employment;
(function (Employment) {
    Employment["Other"] = "other";
    Employment["Retired"] = "retired";
    Employment["FullTimeEmployed"] = "fullTimeEmployed";
    Employment["Student"] = "student";
    Employment["TemporarilyEmployed"] = "temporarilyEmployed";
    Employment["SelfEmployed"] = "selfEmployed";
})(Employment || (Employment = {}));
export var HousingType;
(function (HousingType) {
    HousingType["SingleFamily"] = "singleFamily";
    HousingType["Condominium"] = "condominium";
    HousingType["Apartment"] = "apartment";
})(HousingType || (HousingType = {}));
export var CreditAssessmentStatus;
(function (CreditAssessmentStatus) {
    CreditAssessmentStatus["Received"] = "received";
    CreditAssessmentStatus["SigningInitiated"] = "signingInitiated";
    CreditAssessmentStatus["SigningFailed"] = "signingFailed";
    CreditAssessmentStatus["Signed"] = "signed";
    CreditAssessmentStatus["ScoringInitiated"] = "scoringInitiated";
    CreditAssessmentStatus["Scored"] = "scored";
    CreditAssessmentStatus["NotScored"] = "notScored";
    CreditAssessmentStatus["Accepted"] = "accepted";
    CreditAssessmentStatus["Declined"] = "declined";
    CreditAssessmentStatus["Unknown"] = "unknown";
})(CreditAssessmentStatus || (CreditAssessmentStatus = {}));
export var CreditAssessmentDecision;
(function (CreditAssessmentDecision) {
    CreditAssessmentDecision["Approved"] = "approved";
    CreditAssessmentDecision["Rejected"] = "rejected";
    CreditAssessmentDecision["Unknown"] = "unknown";
})(CreditAssessmentDecision || (CreditAssessmentDecision = {}));
export var CreditAssessmentRecommendation;
(function (CreditAssessmentRecommendation) {
    CreditAssessmentRecommendation["Approve"] = "approve";
    CreditAssessmentRecommendation["AssessManually"] = "assessManually";
    CreditAssessmentRecommendation["Reject"] = "reject";
    CreditAssessmentRecommendation["Unknown"] = "unknown";
})(CreditAssessmentRecommendation || (CreditAssessmentRecommendation = {}));
